import { computed } from 'vue'
import { useVueI18n } from '../locales'
import { ELEMENTS_LOOKUP } from './elements'
const t = useVueI18n()

export const GROUP_LOOKUP = {
  GROUP_FIELDS: 'GroupFields',
  CHECKBOX_GROUP: 'CheckboxGroup',
}

export const GROUP_NAME = {
  [GROUP_LOOKUP.CHECKBOX_GROUP]: 'Checkbox Group',
}

export const ELEMENT_GROUP_LOOKUP_MAP = {
  [ELEMENTS_LOOKUP.CHECKBOX]: GROUP_LOOKUP.CHECKBOX_GROUP,
}

export const GROUP_RULE_OPTION_VALUES = {
  SELECT_AT_LEAST: 'select-at-least',
  SELECT_AT_MOST: 'select-at-most',
  SELECT_EXACTLY: 'select-exactly',
}

export const groupRuleOptions = () => {
  const t = useVueI18n()
  return computed(() => [
    {
      label: t('common.selectAtLeast'),
      value: GROUP_RULE_OPTION_VALUES.SELECT_AT_LEAST,
    },
    {
      label: t('common.selectAtMost'),
      value: GROUP_RULE_OPTION_VALUES.SELECT_AT_MOST,
    },
    {
      label: t('common.selectExactly'),
      value: GROUP_RULE_OPTION_VALUES.SELECT_EXACTLY,
    },
  ])
}

// Non-reactive version for non-Vue contexts
export const getGroupRuleOptions = [
  {
    get label() { return t('common.selectAtLeast') },
    value: GROUP_RULE_OPTION_VALUES.SELECT_AT_LEAST,
  },
  {
    get label() { return t('common.selectAtMost') },
    value: GROUP_RULE_OPTION_VALUES.SELECT_AT_MOST,
  },
  {
    get label() { return t('common.selectExactly') },
    value: GROUP_RULE_OPTION_VALUES.SELECT_EXACTLY,
  },
]

export const GROUP_META = {
  GROUP_TYPE: 'groupType',
  RULE: 'rule',
  RULE_VALUE: 'ruleValue',
}
